import { BoxProps, Flex } from '@chakra-ui/react'

export const FloatingContainer = (props: BoxProps) => (
  <Flex
    py={[1, 2, 4]}
    px={[2, 3, 5]}
    position="relative"
    width="100%"
    direction="column"
    borderRadius={6}
    boxShadow="1px 2px 7px #777"
    overflow="hidden"
    background="white"
    _dark={{ background: 'gray.900' }}
    {...props}
  />
)
